/*

{
  teamId: <String>, // UUID string
  orgId: <String>, // All team members must be on the same orgId
  managerId: <String>, // UserId of the user who created the team
  name: <String>, // Name of the team. Ex: Inpatient Nurses, Outpatient PT
}

*/

const { DataTableBase } = require('./base.class');
const { identifiers } = require('../datastructComponents');
const Joi = require('joi');
const { STATES, USER_TYPES } = require('@bcm/constants');

const schema = {
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  teamId: Joi.string().required(),
  orgId: Joi.string().required(),
  managerId: Joi.string().required(),
  managerType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  teamName: Joi.string().required(),
  teamDisplayName: Joi.string().required(),
};

class Team extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.team.buildPk(obj.orgId),
      identifiers.team.buildSk(obj.state, obj.orgId, obj.teamId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Team = Team;
exports.teamSchema = schema;